import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CreditCardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"credit_card"}/>
}
